import React from 'react';
import { CircleCheckIcon, ListChecksIcon, TriangleAlertIcon } from 'lucide-react';
import { ValidationCheck } from '../../types/commission';
import { Card } from '../sf/Card';
interface ValidationCardProps {
  title: string;
  checks: ValidationCheck[];
  meta?: string;
}
export function ValidationCard({
  title,
  checks,
  meta
}: ValidationCardProps) {
  const passed = checks.filter(check => check.status === 'pass').length;
  const warnings = checks.length - passed;
  return <Card title={title} icon={ListChecksIcon} iconBg="#06A59A" meta={meta ?? `${passed} passed${warnings ? ` · ${warnings} warning` : ''}`} data-id="element-224" data-mp="2hvmbh4znb1yv">
      <ul className="space-y-3" data-id="element-225" data-mp="2d2jcuig0h2bt">
        {checks.map(check => <li key={check.id} className="flex gap-2.5" data-id="element-226" data-mp="29299ldjlsq0n">
            {check.status === 'pass' ? <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sf-green" aria-label="Passed" data-id="element-227" data-mp="35lqcd4lg8nm6" /> : <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-sf-amber" aria-label="Warning" data-id="element-228" data-mp="30sx5aa2id36x" />}
            <div className="min-w-0" data-id="element-229" data-mp="35a8sbqy28m0r">
              <p className="flex flex-wrap items-center gap-1.5 text-[13px] font-semibold text-sf-text" data-id="element-230" data-mp="3a78ys2ytnqse">
                {check.label}
                {check.tag && <span className="rounded-sm border border-[#B0CDF5] bg-sf-blue-light px-1.5 text-[11px] font-semibold text-sf-blue-dark" data-id="element-231" data-mp="2vg08drn3i1e7">{check.tag}</span>}
              </p>
              <p className={`text-xs ${check.status === 'warning' ? 'text-sf-amber-text' : 'text-sf-weak'}`} data-id="element-232" data-mp="2mftq7sggcd8p">{check.detail}</p>
            </div>
          </li>)}
      </ul>
    </Card>;
}